var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-content",style:({
		backgroundColor: _vm.widget.settings.bgColor,
		fontSize: `${_vm.widget.settings.fontSize}px`
	}),domProps:{"innerHTML":_vm._s(_vm.widget.settings.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }